import OffersV2 from './OffersV2';

export default OffersV2;
